/*
console.log('Execute Custom.js @alankimo');

let shipping_rates_json;

$(document).ready(function() {
  console.log('Execute');
  $.ajax({
    url : 'https://www.petmarkt.com.mx/cart/shipping_rates.json',
    type: 'GET',
    data : {
      "shipping_address[country]": "Mexico",
      "shipping_address[province]": "Nuevo León",
      "shipping_address[zip]": "06040"
    }
  })
  .done(function(data) {
    console.log('Done')
    shipping_rates_json = data.shipping_rates;
    console.log(shipping_rates_json);
  })
  .fail(function(data) {
    console.log('Error');
  })
  .always(function(data) {
    console.log('complete');
  });


});
*/

function getDiscount(customer_id) {
  $('.spinner-background').show();
  let discount_code = document.getElementById("discount-code-input");
  let response_object = {};
  let response_object_encode;
  let cart_content;
  let total_discount;
  let format_total_discount;
  let format_subtotal_discount;
  let format_ganancia_total;
  let cart_subtotal;
  let need_review = true;
  let current_customer_id = customer_id;
  let need_review_customer = false;
  let initial_subtotal = (
    $("[subtotal-money]").attr("subtotal-money-petmarkt") * 1
  ).toFixed(2);
  let initial_subtotal_total = (
    $("[subtotal-money]").attr("total-money") * 1
  ).toFixed(2);
  let difference_on_cart = initial_subtotal_total - initial_subtotal;
  let renew_subtotal;
  let initial_ganancia_total = $("[ganancia-total-money]").attr(
    "ganancia-total-money"
  );
  let initial_ganancia_percentage;
  let costo_mayoreo = $("[costo-mayoreo-money]").attr("costo-mayoreo-money");

  $.ajax({
    url: `${window.__cenv.API_HOST}/api/discounts/lookup/${encodeURIComponent(
      discount_code.value
    )}`,
    type: "GET",
  })
    .done(async function (data) {
      switch (data.response) {
        case "OK":
          let validUntil = data.data.body.ends_at;
          if (validUntil != null) {
            validUntil = new Date(validUntil);
            const now = new Date();
            if (now > validUntil) {
              $("#discount-code-response").fadeIn();
              $("#discount-code-response").addClass("discount-code--error");
              $("#discount-code-response").html(
                `🤔  ${discount_code.value} ya no esta disponible`
              );
              return false;
            } 
          }

          if (data.data.body.prerequisite_customer_ids.length > 0) {
            need_review_customer = true;

            data.data.body.prerequisite_customer_ids.forEach(
              (valid_customer) => {
                if (current_customer_id == valid_customer) {
                  need_review_customer = false;
                }
              }
            );
          }

          if (need_review_customer == true) {
            $("#discount-code-response").fadeIn();
            $("#discount-code-response").addClass("discount-code--error");
            $("#discount-code-response").html(
              `🤔  ${discount_code.value} no es aplicable a tu usuario.`
            );
            return false;
          }

          response_object = data.data.body;
          delete response_object.admin_graphql_api_id;
          response_object_encode = btoa(JSON.stringify(response_object));

          await $.ajax({
            url: "/cart.js",
            type: "GET",
          })
            .done(function (data_cart) {
              cart_content = JSON.parse(data_cart);
              cart_subtotal = cart_content.total_price;

              if (data.data.body.entitled_variant_ids.length > 0) {
                cart_content.items.forEach((line_item) => {
                  data.data.body.entitled_variant_ids.forEach((cupon_item) => {
                    if (line_item.id == cupon_item) {
                      cart_subtotal = line_item.line_price;
                      need_review = false;
                    }
                  });
                });
              } else {
                need_review = false;
              }

              if (need_review == true) {
                $("#discount-code-response").fadeIn();
                $("#discount-code-response").addClass("discount-code--error");
                $("#discount-code-response").html(
                  `🤔  ${discount_code.value} no es aplicable a tu carrito.`
                );
                return false;
              }

              if(data.data.body.target_selection == 'all'){
                let new_sub_total = 0;
                if (data.data.body.value_type === "percentage") {
                  total_discount =
                    (initial_subtotal * (data.data.body.value / -100)).toFixed(2) *
                    1;
                  is_text_response = false;
                } else if (data.data.body.value_type == "fixed_amount") {
                  total_discount = (data.data.body.value * -1).toFixed(2) * 1;
                  is_text_response = false;
                } else if (
                  data.data.body.value_type == "percentage" &&
                  data.data.body.target_type == "shipping_line"
                ) {
                  format_total_discount = "Envío gratis";
                  is_text_response = true;
                }
                new_sub_total = (initial_subtotal - total_discount).toFixed(2) * 1;
                $('[subtotal]').attr('subtotal-money-petmarkt', new_sub_total);
              } else if(data.data.body.target_selection == 'entitled'){
                data.data.body.entitled_product_ids.forEach((item) => {
                  let item_price = $(`[product_id$=${item}]`).attr("data-price");
                  let item_qty = $(`[product_id$=${item}]`).attr("data-qty");
                  let new_sub_total = 0;
                  if(item_price == undefined){return false;}
                  if (data.data.body.value_type === "percentage") {
                    total_discount =
                      ((item_price / 100) * (data.data.body.value / -100)).toFixed(2) *
                      1;
                    total_discount = total_discount * item_qty;
                    new_sub_total = (initial_subtotal - total_discount).toFixed(2) * 1;
                    is_text_response = false;
                  } else if (data.data.body.value_type == "fixed_amount") {
                    total_discount = (data.data.body.value * -1).toFixed(2) * 1;
                    new_sub_total = (initial_subtotal - total_discount).toFixed(2) * 1;
                    is_text_response = false;
                  } else if (
                    data.data.body.value_type == "percentage" &&
                    data.data.body.target_type == "shipping_line"
                  ) {
                    format_total_discount = "Envío gratis";
                    is_text_response = true;
                  }
                  $('[subtotal]').attr('subtotal-money-petmarkt', new_sub_total);
              });
              }

              // Update subtotal & ganacia total
              initial_subtotal = (initial_subtotal - total_discount) + difference_on_cart;
              initial_ganancia_total =
                initial_ganancia_total * 1 + total_discount * 1;
              $("[subtotal-money]").attr("subtotal-money", initial_subtotal);
              renew_subtotal = $("[subtotal-money]").attr("subtotal-money") * 1;

              initial_ganancia_percentage =
                (initial_ganancia_total.toFixed(2) * 100) /
                (renew_subtotal * 1);
              initial_ganancia_percentage =
                initial_ganancia_percentage.toFixed(0);

              if (renew_subtotal == 0) {
                initial_ganancia_percentage = 100;
              }

              if (total_discount % 1 != 0) {
                format_total_discount = `$ ${total_discount.toFixed(2)}`;
                format_subtotal_discount = `$ ${initial_subtotal.toFixed(2)}`;
                format_ganancia_total = `$ ${initial_ganancia_total.toFixed(
                  2
                )} <span>(${initial_ganancia_percentage}%)</span>`;
              } else {
                format_total_discount = `$ ${total_discount}.00`;
                format_subtotal_discount = `$ ${initial_subtotal}.00`;
                format_ganancia_total = `$ ${initial_ganancia_total.toFixed(
                  2
                )} <span>(${initial_ganancia_percentage}%)</span>`;
              }

              template_discount = `
                <div class="cantidad-row discount-code-row">
                  <div class="left"><img src="//cdn.shopify.com/s/files/1/0105/9484/4730/t/34/assets/icon-price.svg?v=10321490783279054435" alt="" class="icon-totals"> Código ${discount_code.value}</div>
                  <div total-cupon total-cupon-money="${total_discount}" class="right">${format_total_discount}</div>
                </div>
              `;

              $(".discount-code-row").remove();
              $(".discount-referal-dropper").after(template_discount);

              // Print new subtotal & ganancia total
              $("[subtotal-money]").html(format_subtotal_discount);
              $("[ganancia-total-money]").html(format_ganancia_total);

              var prevSubtotal = parseFloat(
                $("[total_mercancia]").attr("subtotal")
              );
              var newSubtotal = (prevSubtotal - total_discount).toFixed(2);
              $("[total_mercancia]")
                .attr("subtotal", newSubtotal)
                .html(format_to_Money(newSubtotal));
              read_total_cart();
              // Calculate plan de lealtad y SPEI
              initial_subtotal = (
                $("[subtotal-money]").attr("subtotal-money-petmarkt") * 1
              ).toFixed(2);
              initial_subtotal_total = (
                $("[subtotal-money]").attr("subtotal-money") * 1
              ).toFixed(2);
              difference_on_cart = initial_subtotal_total - initial_subtotal;
              initial_ganancia_total = $("[ganancia-total-money]").attr(
                "ganancia-total-money"
              );
              costo_mayoreo = $("[costo-mayoreo-money]").attr("costo-mayoreo-money");
              let cant_monto_por_volumen = (
                $('[total_descuento_por_volumen]').attr('monto-dto') * 1
              ).toFixed(2);
              let cant_monto_SPEI = (
                $('input[name="attributes[gateway]"][value="SPEI"]').attr('monto-dto') * 1
              ).toFixed(2);
              let total_mayor = (
                $('[total_precio_tienda]').attr('costo-en-tienda') * 1
              ).toFixed(2);
              let shipping_cost = (
                $("[subtotal-money]").attr("shipping-cost") * 1
              ).toFixed(2);

              var total_descuento_por_volumen = ((parseFloat(initial_subtotal)*(parseFloat(cant_monto_por_volumen)/100)));
              var subtotal = parseFloat(initial_subtotal)-parseFloat(total_descuento_por_volumen);
              var total_descuento_por_spei = ((parseFloat(subtotal)*(parseFloat(cant_monto_SPEI)/100)));
              var total_de_ganancia = (parseFloat(total_mayor)-(parseFloat(subtotal) + parseFloat(difference_on_cart) - parseFloat(shipping_cost)));
              var porcentaje_de_ganancia = Math.trunc((parseFloat(total_de_ganancia) / parseFloat(total_mayor)) * 100);
              subtotal += difference_on_cart;

              $('[total_descuento_por_volumen]').html(format_to_Money(total_descuento_por_volumen));
              $('[total_de_ganancia]').html(format_to_Money(total_de_ganancia));
              $('[total_de_ganancia]').attr('ganancia-total-money', total_de_ganancia);
              $('[subtotal]').html(format_to_Money(subtotal));
              $('[subtotal]').attr('subtotal-money', subtotal);
              $('[subtotal]').attr('subtotal-money-petmarkt', parseFloat(initial_subtotal)-parseFloat(total_descuento_por_volumen));
              $('[total_mercancia]').attr('subtotal',subtotal).html(format_to_Money(subtotal));
              $('[total_de_ganancia]').append('<span> (' + porcentaje_de_ganancia + '%)</span>');
              $('[total_descuento_por_volumen]').append('<span> (' + (cant_monto_por_volumen * 1) + '%)</span>');
              $('body').find('input[name="attributes[gateway]"][value="SPEI"]').attr('data-total-discounts', total_descuento_por_spei);
              $('body').find('div[descuento_pronto_pago]').attr('total_pronto_pago', total_descuento_por_spei);
              $('body').find('div[descuento_pronto_pago]').html(format_to_Money(total_descuento_por_spei));
              read_total_cart();
            })
            .fail(function () {
              window.__lib.showToast('Algo salió mal, inténtalo de nuevo mas tarde');
            });

          if (need_review == true) {
            return false;
          }

          localStorage.setItem('couponDiscount', response_object_encode);

          $("#discount-code-response").fadeIn();
          $("#discount-code-response").removeClass("discount-code--error");
          $("#discount-code-response").html(
            `${data.data.message} ${discount_code.value}`
          );
          break;
        case "KO":
          $("#discount-code-response").fadeIn();
          $("#discount-code-response").addClass("discount-code--error");
          $("#discount-code-response").html(
            `${data.data.message} ${discount_code.value} 😎`
          );
        default:
          break;
      }
    })
    .fail(function () {
      window.__lib.showToast('Algo salió mal, inténtalo de nuevo mas tarde');
    })
    .always(function () {
      $('.spinner-background').hide();
    });
}

$(document).on(
  "click",
  "#discount-code-btn",
  function execute_discount_code(e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(".discount-code-row").length != 0) return
    var customer_id = $(this).data("customer_id");
    getDiscount(customer_id);
  }
);

function addToCartWholesale(variant_id) {
  var quantity = $(`input[data-variant-id=${variant_id}]`).val();
  var button = $(`button[data-variant-rel=${variant_id}]`);
  var header = $("[data-site-header]");
  button.html("Agregando...");

  let formData = {
    items: [
      {
        id: variant_id,
        quantity: quantity,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) throw Error("Request fails");
      return fetch("/cart.js", {
        headers: { "Content-Type": "application/json" },
      });
    })
    .then((response) => {
      button.addClass("add-to-cart--ok");
      button.html("Agregado");
      setTimeout(function () {
        button.html("Agregar al Carrito");
        button.removeClass("add-to-cart--ok");
      }, 2000);
      if (response.ok) {
        response.json().then((decoded) => {
          header.trigger("cartcount:update", {
            response: decoded,
          });
        });
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      button.addClass("add-to-cart--ko");
      button.html("AGOTADO");
      setTimeout(function () {
        button.removeClass("add-to-cart--ko");
        button.html("Agregar al Carrito");
      }, 2000);
    });
}

/**
 * Register a single Featured Collection Slider element on Flickity
 * @param {Element} element
 */
function InitSingleFeaturedCollectionSlider(element) {
  if (element == null) throw Error("Invalid Element.");
  if (window.Flickity == null || typeof window.Flickity !== "function") {
    throw Error("Flickity is not in scope.");
  }

  const flickityElem = new Flickity(element, {
    freeScroll: true,
    pageDots: false,
    contain: true,
    groupCells: true,
  });

  // Addes extra height for Flickity viewport
  // to prevent hidde the "Quick view" button on
  // featured collection item.
  const root = $(element);
  const viewport = root.find(".flickity-viewport");
  viewport.height(`${root.first(".productgrid--item").height() + 60}px`);

  return flickityElem;
}

/** Register all single Featured Collection Sliders elements on Flickity */
function InitFeaturedCollectionSliders() {
  document
    .querySelectorAll(".featured-collection-slider")
    .forEach(InitSingleFeaturedCollectionSlider);
}

let resizeTimeout = null;

/** Re register elements on flickity after a window resize */
$(window).resize(() => {
  // Clear previous timeout to prevent multiple triggers of this.
  clearTimeout(resizeTimeout);
  // Timeout used to allow page to resize elements.
  resizeTimeout = setTimeout(InitFeaturedCollectionSliders, 600);
});

/**
 * When Shopify theme editor is in use
 * add a listener for section changes to
 * dynamically register sliders on Flickity
 */
if (Shopify && Shopify.designMode) {
  let sectionLoadTimeout = null;
  $(window).on("shopify:section:load", function (event) {
    const sectionID = `#${event.target.id}`;
    if (sectionID.includes("featured-collection")) {
      clearTimeout(sectionLoadTimeout);
      sectionLoadTimeout = setTimeout(() => {
        const sectionTarget = document.querySelector(sectionID);
        const slider = sectionTarget.querySelector(
          ".featured-collection-slider"
        );
        if (slider != null) {
          InitSingleFeaturedCollectionSlider(slider);
        }
      }, 600);
    }
  });
}

/** Register all featured collection sliders when page is ready */
$(document).ready(InitFeaturedCollectionSliders);

/**
 * Decodes a query string
 * @param {string} stringParams Query string;
 * @returns {Object} JSON like parameters
 */
window.decodeParams = function decodeParams(stringParams) {
  if (!stringParams) return {};
  const params = stringParams.replace(/^\?/, "").split("&");
  if (!params.length) return {};
  const result = {};
  params.forEach(function iter(raw) {
    const [rawKey, rawValue] = raw.split("=");
    const key = decodeURIComponent(rawKey);
    const value = !rawValue ? null : decodeURIComponent(rawValue);
    result[key] = value;
  });
  return result;
};

/**
 * Calculates the time eleapsed to a specific date
 * @param {string} date Ref date
 * @param {string | function} format String template or function
 * @param {boolean} formatResult If format is a function setting this prop as true will attempt to format the result of the function
 */
function countDown(date, format = "%H %M %S", formatResult) {
  var ts = new Date(date) - Date.now();
  var obj = { d: 0, h: 0, m: 0, s: 0 };
  var D = 1000 * 60 * 60 * 24;
  var H = 1000 * 60 * 60;
  var M = 1000 * 60;

  if (ts > 0) {
    obj.d = parseInt(ts / D, 10);
    obj.h = parseInt((ts % D) / H, 10);
    obj.m = parseInt((ts % H) / M, 10);
    obj.s = parseInt((ts % M) / 1000);
  }

  obj.dstr = obj.d.toString().length === 1 ? `0${obj.d}` : obj.d;
  obj.hstr = obj.h.toString().length === 1 ? `0${obj.h}` : obj.h;
  obj.mstr = obj.m.toString().length === 1 ? `0${obj.m}` : obj.m;
  obj.sstr = obj.s.toString().length === 1 ? `0${obj.s}` : obj.s;

  if (typeof format === "string") {
    return countDown.formatter(format, obj);
  } else if (typeof format === "function") {
    var result = format(obj);
    if (formatResult) return countDown.formatter(result, obj);
    return result;
  }
}

countDown.formatter = function formatter(template, refObj) {
  var result = template.replace(/%D/g, refObj.dstr);
  result = result.replace(/%-D/g, refObj.d);
  result = result.replace(/%H/g, refObj.hstr);
  result = result.replace(/%-H/g, refObj.h);
  result = result.replace(/%M/g, refObj.mstr);
  result = result.replace(/%-M/g, refObj.m);
  result = result.replace(/%S/g, refObj.sstr);
  result = result.replace(/%-S/g, refObj.s);
  return result;
};

window.countDown = countDown;

/**
 *
 * @param element
 * @param date
 * @param config
 */
window.$countDown = function $countDown(element, date, config) {
  function tick() {
    var refObj = null;
    countDown(date, (obj) => {
      refObj = obj;
    });
    var stop =
      refObj.d === 0 && refObj.h === 0 && refObj.m === 0 && refObj.s === 0;
    var _config = config;
    if (typeof config === "function") _config = config(refObj);
    var {
      template = "%H %M %S",
      repeat = false,
      interval = 1000,
      destroy = false,
      onDestroy,
    } = _config;
    if (repeat && !stop) {
      setTimeout(tick, interval);
    }
    if (stop && destroy) {
      if (typeof onDestroy === "function") {
        onDestroy();
      } else {
        element.remove();
      }
    } else {
      element.html(countDown.formatter(template, refObj));
    }
  }

  tick();
};

function Accordion(props = {}) {
  const inactiveClass = "accordion--inactive";
  const {
    active = true,
    containerHTMLProps,
    containerClass,
    header,
    headerClass,
    headerHTMLProps,
    headerTitle = "Title",
    headerTitleClass,
    headerTitleHTMLProps,
    headerIcon,
    headerIconClass,
    headerIconHTMLProps,
    body,
    bodyClass,
    bodyHTMLProps,
    onToggle = (x) => x,
    onOpen = (x) => x,
    onClose = (x) => x,
  } = props;

  this.toggle = () => {
    let { active } = this.__state;
    this.__state = active = !active;
    this.$el.toggleClass(inactiveClass);
    this.__onToggle();
    if (active) {
      const element = this.__body[0];
      element.style.height = `${element.scrollHeight}px`;
      this.__onOpen();
    } else {
      const element = this.__body[0];
      element.style.height = 0;
      this.__onClose();
    }
  };

  const $cointainer = $(
    `<div ${Accordion.parseProps(
      Object.assign(
        {},
        {
          class: Accordion.prepareClasses(
            "accordion",
            !active ? inactiveClass : null,
            containerClass
          ),
        },
        containerHTMLProps
      )
    )}></div>`
  );

  let $header = null;
  let $headerIcon = null;
  if (headerIcon) {
    $headerIcon = headerIcon;
  } else {
    $headerIcon = $(
      `<span ${Accordion.parseProps(
        Object.assign(
          {},
          { class: Accordion.prepareClasses("header__icon", headerIconClass) },
          headerIconHTMLProps
        )
      )}><i class="fas fa-chevron-down"></i></span>`
    );
    $headerIcon.on("click", this.toggle);
  }
  const $headerTitle =
    typeof headerTitle !== "string"
      ? headerTitle
      : `<h2 ${Accordion.parseProps(
          Object.assign(
            {},
            {
              class: Accordion.prepareClasses(
                "header__title",
                headerTitleClass
              ),
            },
            headerTitleHTMLProps
          )
        )}>${headerTitle}</h2>`;

  if (typeof header === "string") {
    $header = $(header);
  } else if (header != null) {
    $header = header;
  } else {
    $header = $(
      `<div ${Accordion.parseProps(
        Object.assign(
          {},
          { class: Accordion.prepareClasses("accordion__header", headerClass) },
          headerHTMLProps
        )
      )}></div>`
    );
    $header.append($headerTitle);
    $header.append($headerIcon);
  }

  const $body = $(
    `<div ${Accordion.parseProps(
      Object.assign(
        {},
        { class: Accordion.prepareClasses("accordion__body", bodyClass) },
        bodyHTMLProps
      )
    )}></div>`
  );
  const $content = typeof body === "string" ? $(body) : body;

  $body.append($content);
  $cointainer.append($header);
  $cointainer.append($body);

  this.__state = { activ: false };
  this.__header = $header;
  this.__body = $body;
  this.__onToggle = onToggle;
  this.__onOpen = onOpen;
  this.__onClose = onClose;
  this.$el = $cointainer;
}

Accordion.parseProps = function parseProps(obj) {
  if (obj == null) return "";
  const keys = Object.keys(obj);
  return keys.map((key) => `${key}="${obj[key]}"`).join(" ");
};

Accordion.prepareClasses = function prepareClasses(...classes) {
  return classes
    .reduce((acc, i) => (Array.isArray(i) ? [...acc, ...i] : [...acc, i]), [])
    .filter((i) => i != null)
    .join(" ");
};

var typesClasses = {
  message: "toast",
  success: "toast toast--success",
  warning: "toast toast--warning",
  error: "toast toast--error",
};

window.__lib = window.__lib || {};

window.__lib.showToast = function showToast(
  message,
  timeout = 10000,
  type = "message"
) {
  var container = $(".toast-container");
  if (container.length === 0) return;
  var classes = typesClasses[type] || "toast";
  var element = $(
    `<div style="display:none" class="${classes}"><span>${message}</span></div>`
  );
  container.prepend(element);
  element.show();
  setTimeout(() => {
    element.hide();
    setTimeout(() => {
      element.remove();
    }, 600);
  }, timeout);
};

window.__cdata = {
  vendorURLMap: {
    Instinct:
      "https://www.petmarkt.com.mx/collections/instinct-mexico-distribuidor-de-veterinarias",
    Sportmix:
      "https://www.petmarkt.com.mx/collections/sportmix-wholesomes-mayoreo-distribucion",
    "Trick & Treats":
      "https://www.petmarkt.com.mx/collections/trick-treats-distribuidores-galletas-granel-veterinarias",
    "Un Dos Treats":
      "https://www.petmarkt.com.mx/collections/un-dos-treats-premios-mexicanos-mayoreo-veterinarias",
    Mutt: "https://www.petmarkt.com.mx/collections/mutt-premios-deshidratados-mayoreo-perros",
    "Emerald Pet":
      "https://www.petmarkt.com.mx/collections/emerald-pet-premios-dentales-para-gato-mayoreo",
    "Petit Monsters":
      "https://www.petmarkt.com.mx/collections/petit-monsters-premios-perros-mayoristas-veterinaria",
    Petstar:
      "https://www.petmarkt.com.mx/collections/petstar-carnazas-huesos-mayoreo",
    Kong: "https://www.petmarkt.com.mx/collections/kong-premios-y-pastas-mayoreo-petshops",
    "Pet Naturals":
      "https://www.petmarkt.com.mx/collections/pet-naturals-suplementos-naturales-mayoristas-veterinarias",
    Earthrated:
      "https://www.petmarkt.com.mx/collections/earth-rated-poop-bags-bolsas-desechables-perros-mayoreo",
    Earthbath:
      "https://www.petmarkt.com.mx/collections/shampoo-para-estetica-canina-earthbath",
    "Petit Monsters":
      "https://www.petmarkt.com.mx/collections/petit-monsters-juguetes-para-perros",
    "Dog Line":
      "https://www.petmarkt.com.mx/collections/dog-line-distribuidores-de-collares-y-correas-al-mayoreo",
  },
};

$(
  '.account-page.account-page-addresses .form-action-row button[type="submit"]'
).on("click", function btn_submit(event) {
  event.stopPropagation();
  event.preventDefault();

  var data = {};
  var form = $(this).closest("form");

  form
    .find(".form-field-input, .form-field-checkbox input")
    .each(function eachInput() {
      try {
        var key = this.name.match(/.*?\[(.*)?\]/)[1];
        if (this.type === "checkbox") {
          data[key] = Boolean(this.value);
        } else {
          data[key] = this.value;
        }
      } catch (err) {
        console.warn(err);
      }
    });
  $.post(
    "https://app.petmarkt.com.mx/fetch/ws/customer_address_log.php",
    { customer_id: __st.cid, data: JSON.stringify(data) },
    function callback(response) {
      form.submit();
    }
  ).fail(function failCallback() {
    window.__lib.showToast("Algo salió mal mientras guardábamos tus datos");
  });
});

$(document).on("click", "#reordenar_orden", function () {
  var items = $(this).attr("items");
  var arr = items.split("*");
  var formData = { items: [] };
  for (i = 0; i < arr.length; i++) {
    var item = arr[i];
    if (item != null && item != "") {
      formData.items.push(JSON.parse(item));
    }
  }
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "json",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(formData),
    success: function (data) {
      if (data.status) {
        let errmsg =
          "Algo salió mal mientras intentábamos reordenar el pedido.";
        if (data.message != null) errmsg = data.message;
        window.__lib.showToast(`${errmsg}. ${data.description}`, 1e4, "error");
      } else {
        window.__lib.showToast("Carrito llenado con éxito.", 1e4, "success");
        window.location.href = "/cart";
      }
    },
    error: function (xhr) {
      var err = JSON.parse(xhr.responseText);
      window.__lib.showToast(`${err.message}. ${err.description}`, 1e4, "error");
    },
  });
});
